import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { RequirementDataService } from "../../core/requirements.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-requirement",
    template: require('./requirement.component.html')
})
export class Requirement extends DetailsBase<Nema.Crew.Model.CompetenceRequirement> {

    get nrPersonsToDisplay(): string {
        return this.entity.NrPersons === -1 ? "(All)" : String(this.entity.NrPersons);
    }

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('requirement') requirementEntity: Nema.Crew.Model.CompetenceRequirement,
        @Inject("requirementSections") public requirementSections: Nema.Crew.Model.CompetenceRequirementCollection[],
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        @Inject("activityTypes") public activityTypes: Nema.Crew.Model.ActivityType[],
        @Inject("roleTypes") public roleTypes: Nema.Crew.Model.RoleType[],
        @Inject(RequirementDataService.Id) requirementDataService: RequirementDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, requirementEntity, requirementDataService, $log);

        (<any>this.entity.CompetenceRequirementActivityTypes).load();
        (<any>this.entity.CompetenceRequirementCompetenceTypes).load();
        (<any>this.entity.CompetenceRequirementRoleTypes).load();
    }

    public entityName = "Requirement";

    public editStateName = "app.settings.requirements.edit";

    public listStateName = "app.settings.requirements";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirements/requirement.component.ts